export default "__VITE_ASSET__CVPuPAsm__"